import axios from "axios";
import qs from "qs";
import {SET_ORG_TREE, SET_UNREAD_MESSAGE_INFO, SET_USER_AND_HOTEL_INFO, GET_CRM_UPDATE_CLOSE} from "./mutation-types";
import isCRMUser from "@util/isCRMUser";

export default {
  async getUnreadMessageInfo ({commit}) {
    let queryData = {
      isRead: '0',
      page: 1,
      rows: 3
    };
    let res = await axios.post('/hq-web/notice/loadData', qs.stringify(queryData));
    commit(SET_UNREAD_MESSAGE_INFO, res);
  },

  async getUserAndHotelInfo ({commit, state}) {
    const isCRM = isCRMUser();
    if (isCRM) {
      let res = await axios.get('/hq-agency/user/current');
      commit(SET_USER_AND_HOTEL_INFO, {
        user: res.data
      });
      return res;
    } else {
      let res = await axios.get('/hq-web/reportCenter/userInfo');
      commit(SET_USER_AND_HOTEL_INFO, {
        user: res.data
      });
      return res;
    }
  },

  async getOrgTree ({commit, state}) {
    const isCRM = isCRMUser();
    let res = null;
    if (isCRM) {
      res = await axios.get('/hq-agency/user/agency_tree');
    } else {
      res = await axios.post('/hq-web/reportCenter/treeLoad', qs.stringify({type: '1,2,3,4'}));
    }
    commit(SET_ORG_TREE, res.data);
    return res;
  },

  async queryCrmUpdateClose ({commit}) {
    const isCRM = isCRMUser();
    if (isCRM) {
      const result = await axios.get('/hq-web/crm/member/check-crm-upgrade-close');
      if (result && result.code === '200') {
        commit(GET_CRM_UPDATE_CLOSE, result.data);
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js